import { toast } from "sonner";
import { api } from "@/pos/lib/api";
import { getPrinter, printDocs, saleDoc, kitchenDoc, onlineDoc, getKitchenMode, setKitchenMode } from "@/pos/lib/printer";

let shopCache = null;
const shop = async () => (shopCache = shopCache || (await api.get("/settings")).data);
export const resetShopCache = () => { shopCache = null; };

export async function loadKitchenMode() {
  try { const { data } = await api.get("/print-config"); if (data.kitchen_mode !== getKitchenMode()) setKitchenMode(data.kitchen_mode); } catch (e) { /* guna simpanan tempatan */ }
  return getKitchenMode();
}

const report = (how) => {
  if (how === "intent") toast.message("Menghantar ke RawBT...");
  if (how === "failed" && getPrinter().method === "direct") toast.error("Printer belum disambung. Pergi ke Tetapan → tekan Sambung Printer.");
};

const hasKitchenPrinter = () => !!(localStorage.getItem("alfaz_ble_kitchen_id") || localStorage.getItem("alfaz_ble_kitchen_name"));

// Mod "1 tablet 2 printer": hantar ke printer dapur; jika gagal, cetak di printer kaunter.
async function toKitchenPrinter(docs, opts) {
  if ((await printDocs(docs, { kitchen: true })) !== "failed") return "ble";
  toast.warning("Printer dapur tidak bersambung – tiket dapur dicetak di printer kaunter.");
  return printDocs(docs, opts);
}

export async function printSale(sale) {
  const cfg = getPrinter();
  report(await printDocs([saleDoc(sale, await shop(), cfg.width)]));
}

// manual = butang cetak semula; auto = selepas hantar order ke dapur
export async function printKitchen(order, { manual = false } = {}) {
  const mode = getKitchenMode();
  if (!manual && mode !== "same") return "none";
  const docs = [kitchenDoc(order, getPrinter().width)];
  const how = mode === "same" && hasKitchenPrinter() ? await toKitchenPrinter(docs) : await printDocs(docs);
  report(how);
  return how;
}

// Tablet dapur (mod "tablet"): cetak tiket di printer tablet ini tanpa sentuh.
export const printKitchenAuto = (order) => printDocs([kitchenDoc(order, getPrinter().width)], { socketOnly: true });

export async function printOnline(order, opts) {
  const cfg = getPrinter();
  const docs = [onlineDoc(order, await shop(), cfg.width)];
  const ticket = getKitchenMode() === "same" ? kitchenDoc(order, cfg.width) : null;
  if (ticket && !hasKitchenPrinter()) docs.push(ticket);
  const how = await printDocs(docs, opts);
  if (ticket && hasKitchenPrinter()) await toKitchenPrinter([ticket], opts);
  if (!opts?.socketOnly) report(how);
  return how;
}
